module.exports = __webpack_public_path__ + "k-icons.1634309815908.woff2";